<template>
	<section class="app-container">
		<div class="container records-container">
			<div class="records-component">
				<h1>Odonata Central Records</h1>
				<nav id="filter-menu">
					<div class="clearfix">
						<h4 class="pull-left">Filter Results</h4>
						<a class="pull-right" @click="filterOffside.close()"><i class="fa fa-close fa-2x"></i></a>
					</div>
					<sighting-filters v-if="current_user_loaded" :currentUser="current_user" @filterChanged="filterChanged" hideExcludeiNat="true"></sighting-filters>
				</nav>
				<div class="offside-overlay"></div>
					<div class="records-filter-summary clearfix">
						<sighting-filters-summary v-model="filters"></sighting-filters-summary>
					</div>
					<div class="pull-right records-buttons">
						<button v-if="current_user" class="btn" onclick="mr.modals.showModal($('#downloadData'));"><span class="fa fa-download"></span> Download Results</button>
						<router-link class="btn" :to="{ path: '/maps/', query: { filterqs: getMapFilterQS() }}"><i class="fa fa-map"></i> Map these results</router-link>
						<button class="btn btn-primary btn-filter"><span class="fa fa-filter"></span> Filter Results</button>
					</div>
					<div v-bind:class="{ overlayLoading: loading }">
						<Paging></Paging>
						<PagingSummary v-model="meta"></PagingSummary>
						<div class="loading-overlay" v-show="loading">
							<div class="spinner-wrapper">
								<span class="spinner-text">LOADING</span>
								<span class="spinner"></span>
							</div>
						</div>
						<div class="table-responsive">
							<table class="table-records border--round table--alternate-row">
								<thead>
									<tr>
										<column-sort column-id="id" column-name="OC#" v-on:sortChange="doSort" />
										<th>Image</th>
										<column-sort column-id="taxon.common_name" column-name="Taxon" v-on:sortChange="doSort" />
										<column-sort column-id="checklist.user.last_name" column-name="User" v-on:sortChange="doSort" />
										<column-sort column-id="checklist.location.parent.display_name" column-name="Jurisdiction" v-on:sortChange="doSort" />
										<column-sort column-id="checklist.location.display_name" column-name="Location" v-on:sortChange="doSort" />
										<column-sort column-id="checklist.datetime" column-name="Observed" v-on:sortChange="doSort" />
										<column-sort column-id="status" column-name="Status" v-on:sortChange="doSort" />
										<th></th>
									</tr>
								</thead>
								<tbody>
									<tr v-for="sighting in sightings" :key="sighting.id" :class="'sighting-row ' + getExtraClasses(sighting)">
										<td>{{sighting.id}}</td>
										<td style="padding:0;" :class="sighting.photos.length > 0 ? '' : 'td-no-image'">
											<div class="record-photos sightingGallery" v-if="sighting.photos.length > 0">
												<a class="thumb-link" :href="sighting.photos[0].large" :data-original="sighting.photos[0].original">
													<img class="record-photo" :src="sighting.photos[0].small" alt="">
												</a>
												<a v-for="photo, index in sighting.photos" v-if="index > 0" class="thumb-link" :href="photo.large" :data-original="photo.original"></a>
											</div>
										</td>
										<td class="notranslate" translate="no">{{sighting.taxon_data.common_name}}<br /><em>{{sighting.taxon_data.scientific_name}}</em></td>
										<td>
											<template v-if="sighting.user_data">
												<router-link :to="{ name: 'profile', params: { id: sighting.user_data.id }}">
													{{sighting.user_data.display_name}}
												</router-link>
											</template>
										</td>
										<td class="notranslate" translate="no">
											<div v-if="sighting.jurisdiction_data">
												{{sighting.jurisdiction_data.display_name}}
											</div>
										</td>
										<td class="notranslate" translate="no">
											<div v-if="sighting.location_data">
												{{sighting.location_data.display_name}}
											</div>
										</td>
										<td>
											<span v-if="sighting.checklist_data.datetime">{{ sighting.checklist_data.datetime.split('T')[0] | moment(momentDisplayFormat()) }}</span>
										</td>
										<td>
											<template v-if="sighting.status_data">
												{{sighting.status_data.name}}
											</template>
										</td>
										<td>
											<a href="javascript:void(0)" class="btn btn-default btn--xs" v-on:click="$refs.recordsSightingModal.showSighting(sighting.id)">details</a>
										</td>
									</tr>
								</tbody>
							</table>
						</div>
						<Paging></Paging>
					</div>
				</div>
			</div>
			<sighting-modal 
				uniqueID="recordsSightingID" 
				ref="recordsSightingModal" 
				@sightingChanged="sightingChanged"
				@sightingDeleted="sightingDeleted"
				@sightingModfied="sightingModfied"
				@modalClosed="sightingModalClosed"
				>
				</sighting-modal>

			<div id="downloadData" class="modal-container download-modal" v-if="current_user">
				<div class="modal-content">
					<div class="modal-close modal-close-cross">
					</div> 
					<section class="feature-large bg--white border--round">
						<div class="container download-modal">  
							<div class="row">
								<div class="col-sm-12">
									<h1>Download Request Form</h1>
									<em>Your download will be provided immediately after this form is submitted.</em>
									<br />
									<br />

									<strong>Purpose of download:</strong><br />
		                            <div class="input-radio input-radio--innerlabel">
		                                <input id="downloadPurposePersonal" type="radio" name="downloadPurpose" v-model="download_request.purpose" v-bind:value="'Personal Interest'">
		                                <label for="downloadPurposePersonal">Personal Interest</label>
		                            </div>
		                            <div class="input-radio input-radio--innerlabel">
		                                <input id="downloadPurposeResearchProject" type="radio" name="downloadPurpose" v-model="download_request.purpose" v-bind:value="'Research Project'">
		                                <label for="downloadPurposeResearchProject">Research Project</label>
		                            </div>
		                            <ErrorField :errors="download_request_validation" field="purpose" />
		                            <div v-show="download_request.purpose == 'Research Project'">
		                            	<label>Name of Project:</label>
										<input type="text" v-model="download_request.project_name"  />
	                            		<ErrorField :errors="download_request_validation" field="project_name" />
			                            <strong>Funded:</strong><br />
			                            <div class="input-radio input-radio--innerlabel">
			                                <input id="downloadFundedNo" type="radio" name="downloadFunded" v-model="download_request.funded" v-bind:value="false">
			                                <label for="downloadFundedNo">No</label>
			                            </div>
			                            <div class="input-radio input-radio--innerlabel">
			                                <input id="downloadFundedYes" type="radio" name="downloadFunded" v-model="download_request.funded" v-bind:value="true">
			                                <label for="downloadFundedYes">Yes</label>
			                            </div>
	                            		<ErrorField :errors="download_request_validation" field="funded" />
			                            <div v-show="download_request.funded">
			                            	<label>Funding Source:</label>
											<input type="text" v-model="download_request.funding_source"  />
	                            			<ErrorField :errors="download_request_validation" field="funding_source" />
			                            </div>
		                            </div>
								</div>
								<div class="col-sm-12" style="margin-top:10px;">
									<ErrorField :errors="download_request_validation" field="non_field_errors" />
		                            <button type="submit" class="btn btn--primary type--uppercase" @click="downloadData()">Request Download</button>
								</div>
							</div>
						</div>
					</section>
				</div>
			</div>
		</section>
</template>

<script>
export default {
	name: 'RecordsComponent',
	metaInfo: {
      title: 'Dragonfly & Odonate Sightings and Observations',
      meta: [
        { name: "description", content: 'Dragonfly & Odonate Sightings and Observations collected from users all over the united states and the rest of the world.' },
      ],
    },
	mounted(){
		var self = this;
        self.GetAPIUser(function(user){
        	self.current_user_loaded=true;
            self.current_user = user;
        });
		var parsed_page = parseInt(this.$route.query.page);
		if (!isNaN(parsed_page)) {
			this.page = parsed_page;
		}
		if (this.$route.query.sort) {
			this.sort = this.$route.query.sort;
		}
		if (this.$route.query.sort_direction) {
			if (this.$route.query.sort_direction == "+") {
				this.sort_direction = "";
			}
			else if (this.$route.query.sort_direction == "-") {
				this.sort_direction = "-";
			}
		}

		this.filterOffside = offside( '#filter-menu', {
				buttonsSelector: '.btn-filter',
				slidingSide: 'right', 
		});

		$('.offside-overlay').click(function(){self.filterOffside.close()});

	},
	data: function(){
		return {
			sightings: [],
			meta: {
				page: 0,
				per_page: 0,
				total_pages: 0,
				total_results: 0,
			},
			page: 1,
			loading: true,
			filter_string: '',
			sort:'checklist.datetime',
			sort_direction:'-',
			current_sighting_id:null,
			filterOffside:null,
			filters:null,
			current_user:null,
			current_user_loaded:false,
			needs_refresh: false,
			download_request:{
				purpose: null,
				project_name: null,
				funded: false,
				funding_source: null,
			},
			download_request_validation:null
		};
	},
	methods:{
		downloadData:function(){
			var self = this;
			var qs = this.filter_string;
            this.API({
                endpoint: 'download',
        		querystring: qs,
                isPost:true,
                postData: self.download_request,
                funcThen: function(response){
                	console.log(response);
                	window.open(
                		self.APIFullURL({
	                		endpoint: 'download/' + response.data.download_request.id,
			        		querystring: qs
	                	})
                	);
                },
                funcCatch: function(error) {
                    self.download_request_validation = error.response.data;
                },
            });
		},
		getMapFilterQS:function(){
			var ret = this.$route.query.filterqs + "|excludeinat";
			return ret;
		},
		sightingModalClosed:function(){
			if (this.needs_refresh) {
				this.needs_refresh = false;
				this.getData();
			}
		},
		getExtraClasses:function(sighting){
			var classes = ''
			if(sighting.deleted){
				classes += " sighting-row-deleted";
			}
			return classes;
		},
		getNextSightingID:function(){
			if (this.current_sighting_id == null) {return null;}
			var current_sighting_index = this.sightings.findIndex(s => s.id == this.current_sighting_id);
			if (this.sightings[current_sighting_index + 1]) {
				return this.sightings[current_sighting_index + 1].id;
			}
			if (this.page < this.meta.total_pages) {
				this.$refs.recordsSightingModal.setwaiting('next');
				this.page = this.page + 1;
				return "?next";
			}
			return null;
		},
		getPreviousSightingID:function(){
			if (this.current_sighting_id == null) {
				if (this.failed_id) {
					return this.failed_id;
				}
				return null;
			}
			var current_sighting_index = this.sightings.findIndex(s => s.id == this.current_sighting_id);
			if (this.sightings[current_sighting_index - 1]) {
				return this.sightings[current_sighting_index - 1].id;
			}
			if (this.page > 1) {
				this.$refs.recordsSightingModal.setwaiting('previous');
				this.page = this.page - 1;
				return "?previous";
			}
			return null;
		},
		getPreviousSightingExists:function(){
			if (this.current_sighting_id == null) {return false;}
			if (this.page > 1) {return true;}
			var current_sighting_index = this.sightings.findIndex(s => s.id == this.current_sighting_id);
			return current_sighting_index > 0;
		},
		getNextSightingExists:function(){
			if (this.current_sighting_id == null) {return false;}
			if (this.page < this.meta.total_pages) {return true;}
			var current_sighting_index = this.sightings.findIndex(s => s.id == this.current_sighting_id);
			return current_sighting_index < this.sightings.length  - 1;
		},
		sightingModfied:function(id){
			this.needs_refresh = true;
		},
		sightingChanged:function(id){
			this.current_sighting_id = id;
		},
		sightingDeleted:function(deleted_id){
			var deleted_sighting = this.sightings.find(s => s.id == deleted_id);
			deleted_sighting.deleted = true;
		},
		doSort:function(sort){
			this.page = 1;
			if (this.sort == sort) {
				if (this.sort_direction === '') {
					this.sort_direction = '-';
				}
				else{
					this.sort_direction = '';
				}
			}
			else{
				this.sort = sort;
			}
			this.getData();
		},
		getAPIquerystring: function(){
			var qs = "&include[]=checklist.user.*";
			qs += "&include[]=checklist.location.*";
			qs += "&include[]=checklist.location.parent.*";
			qs += "&include[]=status.*";
			qs += "&include[]=checklist.*";
			qs += "&include[]=taxon.*";
			qs += this.filter_string;
			if (this.sort !== "") {
				qs+="&sort[]=" + this.sort_direction + this.sort;
			}
			qs += "&page=" + this.page;
			qs += "&sort=" + this.sort;
			qs += "&sort_direction=" + this.sort_direction;
			return qs;
		},
		getData: function(){
			this.loading = true;
			var self = this;
			var qs = this.getAPIquerystring();
			this.API({
				endpoint: 'sightings',
				querystring: qs,
				funcThen: function(response){
					self.cleanResponseData(response.data);
					if (self.$refs.recordsSightingModal.getwaiting() === "next") {
						self.$refs.recordsSightingModal.showSighting(self.sightings[0].id);
					}
					else if (self.$refs.recordsSightingModal.getwaiting() === "previous") {
						self.$refs.recordsSightingModal.showSighting(self.sightings[self.sightings.length - 1].id);
					}
				},
				funcAfterThen: function(){
					self.loading = false;
					$('.sightingGallery').each(function(){
						$(this).magnificPopup({
							type: 'image',
							delegate: 'a.thumb-link',
							gallery:{
								enabled:true
							},
							image:{
								titleSrc: function(item){
									return "<a class='original-photo' href='"+ item.el.attr('data-original') +"' target='_blank'><strong>Original Photo</strong></a>"; 
								}
							}
						});
					});
					
				}
			});
		},
		
		cleanResponseData: function(data){
			this.meta = data.meta;
			this.sightings = this.CombineSightingData(data);
		},
		filterChanged: function(filters,filter_string,by_user_action){
			console.log(filter_string);
			this.filters = JSON.parse(JSON.stringify(filters));
			if (by_user_action) {
				this.page = 1;
			}
			this.filter_string = filter_string;
			this.getData();
			if (this.filterOffside) {
				this.filterOffside.close();
			}
		}
	},
	computed: {
		max_page: function(){
			return this.meta.total_pages;
		}
	},
	watch:{
		page: function(){
			let query = Object.assign({}, this.$route.query);
			query.page = this.page;
			this.$router.replace({query: query});
			this.getData();
		},
		sort: function(){
			let query = Object.assign({}, this.$route.query);
			query.sort = this.sort;
			this.$router.replace({query: query});
			this.getData();
		},
		sort_direction: function(){
			let query = Object.assign({}, this.$route.query);
			if (this.sort_direction == "") {
				query.sort_direction = "+";
			}
			else{
				query.sort_direction = this.sort_direction;
			}
			this.$router.replace({query: query});
			this.getData();
		}
	}
}
</script>


// WEBPACK FOOTER //
// src/components/pages/Records.vue